<template>
  <div class="background" :class="{'long':long}" id="background">
    <div class="chart-container" :class="{'longCont':long}" id="chart-container">
      <div v-html="styleText"></div>
      <div @click="printPdf" class="noPrint">{{$t('print')}}</div>
      <div class="Hcp-main-header">
        <div class="main-header-left">
          <img src="../../assets/LOGO.png">
        </div>
        <div class="main-header-right">
          <p>{{$t('EventReport')}} ({{$t('By Date')}})</p>
          <p>{{$t('period')}}:{{days}}</p>
        </div>
      </div>
      <table class="status-table1">
        <tr>
          <td class="td4">{{$t('uername')}}: {{statics.username}}</td>
          <td class="td4">{{$t('fullName')}}: {{statics.name}}</td>
          <td class="td4">{{$t('disType')}}: {{statics.medical_history}}</td>
          <td>{{$t('HbA1c')}}: {{hb1c}}</td>
        </tr>
      </table>
      <div class="small-hr"></div>
      <p style="margin-left:29px;margin-top: 20px;">{{$t('Event Summary')}}</p>

      <div v-for="(base, p) in pagePos">
        <div v-if="p>=1">
          <div class="page-seperator"></div>
          <div class="page-starter">
            <!--<br/><br/><br/><br/>-->
          </div>
        </div>

        <table class="events-table" style="margin-top: 5px;">
          <tr>
            <td class="td5" width="52px">{{$t('date')}}</td>
            <td class=" spe1 td5"></td>
            <td v-for="i in hours"  class="td2">{{i}}</td><td class="spe2 td5">Avg/#</td>
          </tr>
        </table>
        <table class="events-table" v-for="(day,index) in whichDate.slice(base, base+perPage[p])" :id="base+index">
          <tr>
            <td rowspan="4" class="td1 td4" width="52px">{{day}}</td>
            <td class="td1 spe1">{{$t('BG1')}}</td>
            <td v-for="i in 24"></td><td class="td1 spe2"></td>
          </tr>
          <tr>
            <td class="td3">{{$t('carbs')}}</td>
            <td v-for="i in 24"></td>
            <td class="td1 spe2"></td>
          </tr>
          <tr>
            <td class="td3">{{$t('Injection')}}</td>
            <td v-for="i in 24"></td>
            <td class="td1 spe2"></td>
          </tr>
          <tr>
            <td class="td3 td4">{{$t('exercise')}}</td>
            <td v-for="i in 24" class="td4"></td>
            <td class="td1 td4 spe2"></td>
          </tr>
        </table>

      </div>

      <div v-if="chartEndPage.show">
        <div class="page-seperator"></div>
        <div class="page-starter">
          <!--<br/><br/><br/><br/>-->
        </div>
      </div>

      <div class="statics">
        <p class="custom">{{$t('static')}}</p>
        <table class="statics-table">
          <tr>
            <td class="td1">{{$t('type')}}</td><td class="td1">{{$t('Avg')}}</td><td class="td1">{{$t('SD')}}</td>
            <td class="td1">{{$t('max')}}</td><td class="td1">{{$t('min')}}</td><td class="td2">{{$t('#')}}</td>
          </tr>
          <tr>
            <td class="td1">{{$t('BG1')}}</td><td class="td1">{{bgstat.day.avg}}</td> <td class="td1">{{bgstat.day.sd}}</td>
            <td class="td1">{{bgstat.day.max}}</td> <td class="td1">{{bgstat.day.min}}</td><td class="td2">{{bgstat.day.num}}</td>
          </tr>
          <tr>
            <td class="td1">{{$t('carbs')}}</td><td class="td1">{{carbstat.day.avg}}</td> <td class="td1">{{carbstat.day.sd}}</td>
            <td class="td1">{{carbstat.day.max}}</td> <td class="td1">{{carbstat.day.min}}</td><td class="td2">{{carbstat.day.num}}</td>
          </tr>
          <tr>
            <td class="td1">{{$t('Injection')}}</td><td class="td1">{{bolstat.day.avg}}</td> <td class="td1">{{bolstat.day.sd}}</td>
            <td class="td1">{{bolstat.day.max}}</td> <td class="td1">{{bolstat.day.min}}</td><td class="td2">{{bolstat.day.num}}</td>
          </tr>
          <tr>
            <td class="td3">{{$t('exercise')}}</td><td class="td3">{{exerstat.day.avg}}</td> <td class="td3">{{exerstat.day.sd}}</td>
            <td class="td3">{{exerstat.day.max}}</td> <td class="td3">{{exerstat.day.min}}</td><td>{{exerstat.day.num}}</td>
          </tr>
        </table>
      </div>

      <div class="page-end"></div>

    </div>
  </div>
</template>

<script>
  import * as echarts from 'echarts'
  import auth from '../../auth/auth'
      import format from '@/lib/format'
  import B64 from '../../auth/base64'
  export default{
    data() {
      return {
        whichDate: [],isMg:"",
        hours: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00',
          '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'],
        uid: 0, st: 0, et: 0,days:'',dayNum:0,ts:[],
        statics: {}, hb1c: ['--'],long:false,
        pagePos:[],perPage:[],chartEndPage:{show:false},
        styleText:'<style type="text/css" media="print">@page{size:landscape;margin:0;}</style>',
        bgstat: {"day":
          {
            "avg": "--",
            "max": "--",
            "min": "--",
            "num": "--",
            "sd": "--",
            "total": "--"
          },
        },
        carbstat: {"day":
          {
            "avg": "--",
            "max": "--",
            "min": "--",
            "num": "--",
            "sd": "--",
            "total": "--"
          },
        },
        bolstat: {"day":
          {
            "avg": "--",
            "max": "--",
            "min": "--",
            "num": "--",
            "sd": "--",
            "total": "--"
          },
        },
        exerstat: {"day":
          {
            "avg": "--",
            "max": "--",
            "min": "--",
            "num": "--",
            "sd": "--",
            "total": "--"
          },
        },
      }
    },
    methods:{
      getStatics(){
        if(sessionStorage.getItem('userType')!=='P'){
          this.uid = parseInt(sessionStorage.getItem('patientId'));
        }else{
          this.uid = parseInt(sessionStorage.getItem('uid'));
        }
        this.ts =auth.getTs(this.st,this.et);
        let param = {
          ts:this.ts,
          tz:parseInt(sessionStorage.getItem('tz')),
          gu:(this.isMg)?'mg/dL':'mmol/L',
        };
       // console.log(param)
        param = B64.base64encode(JSON.stringify(param));
        this.$http.get('api/v2.1/report/'+this.uid+'/data/erd',{params:{param}}).then(function (res) {
          let err =res.body.error;
          if(err === 0){
            let data =  res.data.data;
            data.medical_history = (data.medical_history )?this.$t(data.medical_history):"--";
            if(data.medical_history){
              data.medical_history = data.medical_history.split(',')[0];
            }
            this.statics = data;
            this.hb1c = (data.hba1c)?data.hba1c:this.hb1c;
            this.bgstat = (data.event_period_stat.bg)?data.event_period_stat.bg:this.bgstat;
            this.carbstat = (data.event_period_stat.carb)?data.event_period_stat.carb:this.carbstat;
            this.bolstat = (data.event_period_stat.bolus)?data.event_period_stat.bolus:this.bolstat;
            this.exerstat = (data.event_period_stat.exer)?data.event_period_stat.exer:this.exerstat;
            let that =this;
            data.event_summary_bytime.map(function (e,i) {
              e.bg = that.makeBg(e.bg,i);
              e.carb = that.makeCarb(e.carb,i,1);
              e.bolus = that.makeCarb(e.bolus,i,2);
              e.exer = that.makeCarb(e.exer,i,3);
            });
          }
        },function(err){
          let tip =  this.$t('tryAgain');
          this.$message.error(tip);
        })
      },
      makeBg(val,i){
        const table = document.getElementById(i);
        const tr = table.getElementsByTagName('tr')[0];
        const h = 'hour';
        if(val.no_data){
          const td =tr.getElementsByTagName('td');
          let tip1 = this.$t('No1');
          let tip2 = this.$t('data1');
          td[2].innerHTML = tip1;
          td[2].style.textAlign = 'right';
          td[3].innerHTML = tip2;
          td[3].style.textAlign = 'left';
        }else{
          for(let item in val){
            if(item.indexOf(h)>=0){
              let j = parseInt(item.replace(/[^0-9]/ig,""));
              const td =tr.getElementsByTagName('td')[j+2];
              td.innerHTML = val[item]
            }else{
              const td =tr.getElementsByTagName('td')[26];
              td.innerHTML =val.total;
            }
          }
        }
      },
      makeCarb(val,i,type){
        const table = document.getElementById(i);
        const tr = table.getElementsByTagName('tr')[type];
        const h = 'hour';
        if(val.no_data){
          const td =tr.getElementsByTagName('td');
          let tip1 = this.$t('No1');
          let tip2 = this.$t('data1');
          td[1].innerHTML = tip1;
          td[1].style.textAlign = 'right';
          td[2].innerHTML = tip2;
          td[2].style.textAlign = 'left';
        }else{
          for(let item in val){
            if(item.indexOf(h)>=0){
              let j = parseInt(item.replace(/[^0-9]/ig,""));
              const td =tr.getElementsByTagName('td')[j+1];
              td.innerHTML = val[item]
            }else{
              const td =tr.getElementsByTagName('td')[25];
              td.innerHTML =val.total;
            }
          }
        }
      },
      printPdf(){
        auth.print_page();
      },
    },
    mounted: function () {
      self.document.title = this.$t('EventReport');
      let lang = sessionStorage.getItem('language');
      this.isEn = (lang!=='zh'&&lang !=='hk')?true:false;
      this.isMg = (localStorage.getItem('unit')==='mg')?true:false;
      let t2= parseInt(sessionStorage.getItem('qet6'));
      let t1= parseInt(sessionStorage.getItem('qst6'));
      this.dayNum =parseInt((t2-t1)/86400+1);
      if(this.dayNum>13){
        this.long = true;
      }
      this.days = format.formatterDate2(t1)+' - '+format.formatterDate2(t2);
      for(let i=0;i<this.dayNum;i++){
        let ti = format.formatterDate2(t1+i*86400)+' '+format.formatterDay(this,t1+i*86400);
        this.whichDate[i] =ti;
      }
      //
      let page_index=0;
      let PER_PAGE1=9;
      let PER_PAGE2=10;
      while (page_index < this.whichDate.length) {
        this.pagePos.push(page_index);
        if (1==this.pagePos.length) {
          page_index += PER_PAGE1;
          this.perPage.push(PER_PAGE1);
        } else {
          page_index += PER_PAGE2;
          this.perPage.push(PER_PAGE2);
        }
      }
      let chartNum=this.whichDate.length;
      if (chartNum < 8) {
        this.chartEndPage.show=false;
      } else if (8==chartNum) {
        this.chartEndPage.show=true;
      }else if (((chartNum-9)%10)==0) {
        this.chartEndPage.show=true;
      }

      console.log('pagePos:', this.pagePos);
      let pageNum=this.pagePos.length;
      if (8==chartNum || 9==chartNum) {
        pageNum += 1;
      }
      //document.getElementById('background').style.height=((pageNum*210)+0)+'mm';
      //document.getElementById('chart-container').style.height=((pageNum*210)+0)+'mm';
      //
      this.st=t1;
      this.et=t2;
      this.getStatics();
      let first = parseInt(sessionStorage.getItem('qFirst6'));
      if(first===1){
        auth.checkPrint(this,8,6);
      }
    },
  }
</script>

<style scoped meadia="print">
  /*@page{
    *size:auto;
    size:landscape;
    margin: 0;
  }*/
  .background{
    padding-top: 5mm;
    width: 100%;
    *min-height: 209mm;
    background: #ccc;
  }
  .background .noPrint{
    float: left;
    border-radius:100px;
    background: #fff;
    border: 1px solid #a3a3a3;
    outline: none;
    margin-top:4px;
    width:90px;
    height:26px;
    line-height: 28px;
    cursor: pointer;
    margin-left:-140px;
    font-size: 13px;
    text-align: center;
  }
  @media print {
    .background .noPrint{
      display: none;
    }
  }
  .chart-container {
    width:297mm;
    *height:209mm;
    font-family:SFUIText-Regular;
    font-size:13px;
    color:#282828;
    letter-spacing:-0.34px;
    background: #fff;
    margin:0 auto;
    padding-left: 20px;
    padding-right: 20px;
  }
  .long{
    *min-height: 594mm;
  }
  .longCont{
    *height: 594mm;
  }
  @media screen and (max-width: 1450px){
    .background .noPrint{
      position: absolute;
      left: 20%;
      top: -1px;
    }
    .chart-container{
      margin-top: 20px;
    }
  }
  .Hcp-main-header{
    width:97%;
    height:40px;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:12px;
    color:#282828;
    padding-top: 10px;
  }
  .main-header-left{
    float: left;
  }
  .main-header-left img{
    height:45px;
    width: 100px;
  }
  .main-header-right{
    float: right;
    text-align: right;
    padding-top: 10px;
    margin-right: 15px;
  }
  .main-header-right p{
    font-size:12px;
    margin-bottom: 5px;
    letter-spacing:-0.29px;
    font-family:SFUIText-Regular;
    color:#282828;
  }

  .status-table1{
    width: 94%;
    margin:20px auto 16px;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
    text-align:left;
    table-layout: fixed;
  }
  .status-table1 td{
    padding-left: 10px;
    height:20px;
  }
  .status-table1 .td4{
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .small-hr{
    width:94%;
    margin:10px auto 16px;
    border-top:1px solid #3b3b3b;
  }

  .events-table{
    width: 94%;
    margin:0 auto;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
    text-align:center;
    table-layout: fixed;
  }
  .events-table td{
    height: 16px;
    font-size: 12px;
    -webkit-transform: scale(0.8);
    -moz-transform: scale(0.8);
    -ms-transform: scale(0.8);
    -o-transform: scale(0.8);
    transform: scale(0.8);
  }
  .events-table .td1{
    border-left:1px solid rgba(116,116,116,0.34);
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .events-table .td2{
    border-bottom:1px solid rgba(116,116,116,0.34);
    border-top:1px solid rgba(116,116,116,0.34);
    font-size: 12px;
    -webkit-transform: scale(0.65);
    -moz-transform: scale(0.65);
    -ms-transform: scale(0.65);
    -o-transform: scale(0.65);
    transform: scale(0.65);
    color:#282828;
  }
  .events-table .td3{
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .events-table .td4{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }
  .events-table .td5{
    border:1px solid rgba(116,116,116,0.34);
  }
  .events-table .spe1{
    width: 70px;
  }
  .events-table .spe2{
    width: 50px;
  }

  .statics{
    margin-top: 25px;
    margin-bottom: 17px;
  }
  .statics p{
    margin-left: 3%;
    font-family:SFUIText-Regular;
    font-size:13px;
    color:#282828;
    letter-spacing:-0.27px;
    text-align:left;
    padding-left: 3px;
  }
  .statics-table{
    width: 94%;
    margin:6px auto 0;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
    text-align:center;
    table-layout: fixed;
  }
  .statics-table td{
    height:20px;
  }
  .statics-table .td1{
    border-bottom:1px solid rgba(116,116,116,0.34);
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .statics-table .td2{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }
  .statics-table .td3{
    border-right:1px solid rgba(116,116,116,0.34);
  }

  .page-seperator {
    *height:20mm;
    page-break-before:always;
  }
  .page-starter {
    height:10mm;
  }

  .page-end {
    clear: both;
    height:1mm;
  }

</style>



// WEBPACK FOOTER //
// quickPrint6.vue?7814af46